module.exports = __webpack_public_path__ + "static/media/offlineTasks.fa7c2bf6.svg";